// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3hHPJ","options":"AnswerScale_options__2UwB3","selected":"AnswerScale_selected__12o29"};